import { render } from "./AcademicSystemsEditor.vue?vue&type=template&id=0fcf5d4e&scoped=true"
import script from "./AcademicSystemsEditor.vue?vue&type=script&lang=js"
export * from "./AcademicSystemsEditor.vue?vue&type=script&lang=js"

import "./AcademicSystemsEditor.vue?vue&type=style&index=0&id=0fcf5d4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcf5d4e"]])

export default __exports__